import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import TournamentsPage from './pages/TournamentsPage';
import RankingsPage from './pages/RankingsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import PalmaresPage from './pages/PalmaresPage';
import AdminPage from './pages/AdminPage';
import Top8StandingsPage from './pages/Top8StandingsPage';
import DisplayPage from './pages/DisplayPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/tournois" element={<TournamentsPage />} />
            <Route path="/classement" element={<RankingsPage />} />
            <Route path="/statistiques" element={<AnalyticsPage />} />
            <Route path="/palmares" element={<PalmaresPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/top8" element={<Top8StandingsPage />} />
            <Route path="/display" element={<DisplayPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
